import { useMemo, useState } from 'react';

/**
 * Marks the element that owns a scroll region, so descendants can find it.
 */
export const SCROLL_CONTAINER_DATA_ATTR = 'data-scroll-container';

export const SCROLL_CONTAINER_SELECTOR = `[${SCROLL_CONTAINER_DATA_ATTR}]`;

/**
 * Resolves the nearest marked scroll container above an anchor element.
 */
export const useScrollParent = () => {
  // A callback ref rather than useRef because the anchor can mount several
  // renders after the component's first commit (e.g. once loading resolves),
  // which a mount effect would miss.
  const [anchorNode, setAnchorNode] = useState<HTMLElement | null>(null);

  const scrollParent = useMemo(
    () =>
      anchorNode?.closest<HTMLElement>(SCROLL_CONTAINER_SELECTOR) ?? undefined,
    [anchorNode],
  );

  return { anchorRef: setAnchorNode, scrollParent };
};
